import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isTsrAdminAuthenticated } from '../auth/tsrAdminAuth';

function TsrAdminRoute() {
  if (!isTsrAdminAuthenticated()) {
    return <Navigate to="/tsr-admin" replace />;
  }
  return <Outlet />;
}

export default TsrAdminRoute;
